
import { useNavigate } from "react-router-dom";
import { getUserCourses } from "@/lib/user-courses";
import { useAuth } from "@/contexts/AuthContext";

export function usePurchaseNavigation(course: { id?: string } | null | undefined) {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Returns a callback to use on "purchase" CTA click
  const onPurchase = async () => {
    if (!course) return;
    if (user && course.id) {
      const courses = await getUserCourses(user.id);
      const found = courses.find((c: any) => c.course_id === course.id);
      if (found) {
        navigate(`/learner/course/${course.id}`);
        return;
      }
    }
    if (course.id) navigate(`/checkout/${course.id}`);
  };
  return onPurchase;
}
